import React from 'react';
import classes from './FormSearch.module.scss';

function FormSearch(props) {
    return <div className={`${classes['FormSearch']} ${props?.className}`}>{props?.children}</div>;
}

export default FormSearch;
